import React from 'react';
import { createRoot } from 'react-dom/client';

import LoginApp from './LoginApp';

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);
root.render(<LoginApp />);
